import { Pagination } from '@heroui/react';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { answerToChartLabel } from '@/patient-app-common/helpers/progress_helper';
import useSegment from '@/hooks/useSegment';

const EVENT = 'Progress chart all entries viewed';

export function EntryList({ question, filteredEntries, mode }) {
  const { sendTrackEvent } = useSegment();
  const { pathname } = useLocation();

  const entries = filteredEntries
    ? [...filteredEntries]
    : [...question.patientEntries];
  _.remove(entries, { skipped: true });
  _.remove(entries, ({ answer }) => !_.isNumber(answer) && _.isEmpty(answer));
  entries.sort((a, b) => dayjs(b.date) - dayjs(a.date));

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const totalPages = Math.ceil(entries.length / itemsPerPage);
  const entriesToShow = entries.slice(startIndex, startIndex + itemsPerPage);

  const eventData = {
    id: question.id,
    pathname,
    procedureId: question.procedureId,
    procedureName: question.surveyName,
    questionType: question.type,
    title: question.title,
  };

  useEffect(() => {
    if (question.type !== 'text') return;
    sendTrackEvent(EVENT, { ...eventData, timeFrame: 'all' });
  }, []);

  const formatDate = (date) => {
    switch (mode) {
      case 'day':
        return dayjs(date).format('LLL');

      case 'week':
        return dayjs(date).format('LL');

      case 'all':
      default:
        return dayjs(date).format('LL');
    }
  };

  return (
    <>
      {entriesToShow.map(({ answer, date }) => {
        const parsedAnswer = answerToChartLabel(question, answer);
        const formattedDate = formatDate(date);
        return (
          <div>
            <p className="font-semibold mb-2">{formattedDate}</p>
            <p className="break-words font-light whitespace-pre-wrap">
              {parsedAnswer} {question.unit}
            </p>
          </div>
        );
      })}
      {entries.length > itemsPerPage && (
        <Pagination
          color="primary"
          isCompact
          page={currentPage}
          showControls
          total={totalPages}
          onChange={setCurrentPage}
        />
      )}
    </>
  );
}
